import React, {useState} from "react";
import TableWrapperV2Component
    from "../../../shared/components/table-components/table-wrapper-v2/TableWrapperV2Component";
import {APIConfig} from "../../../constants";
import {ITableColumn} from "../../../shared/models/table.model";
import {IBarcode} from "../../../shared/models/barcode.model";
import TooltipComponent from "../../../shared/components/tooltip/tooltipComponent";
import {CommonService} from "../../../shared/services";
import PictureAsPdfIcon from "@mui/icons-material/PictureAsPdf";

interface BarcodesProductsBasedListComponentProps {
    filterData: {};
}


const BarcodesListTableComponent = (props: BarcodesProductsBasedListComponentProps) => {
    const {filterData} = props;

    const [columns] = useState<ITableColumn[]>([
        {
            id: 'testName', label: 'Test Name', isDefaultColumn: true,
            fixed: "left",
            width: "230",
            content: (item: IBarcode) => (
                <>
                    {
                        item?.testName?.length > 23 ?
                            <TooltipComponent
                                tooltip={CommonService.capitalizeFirstLetterOfEachWord(item?.testName)}
                                placement={"top"}
                                arrow={true}
                            >
                                <div className={"ellipses-for-table-data"}>
                                    {CommonService.capitalizeFirstLetterOfEachWord(item?.testName)}
                                </div>
                            </TooltipComponent> :
                            <>
                                {CommonService.capitalizeFirstLetterOfEachWord(item?.testName)}
                            </>
                    }
                </>
            )
        },
        {
            id:'quantity', label: 'Quantity', isDefaultColumn: true,align: "center",
        },

        {
            id: 'title', label: 'Import Title', align: "center",
            isDefaultColumn: true, width: "250",
            content: (item: any) => (
                <>
                    {
                        item?.title ?
                            <>
                                {item.title}
                            </> : <> - </>
                    }
                </>
            )
        },
        {
            id: 'pdf', label: 'Document', isDefaultColumn: true,
            align: 'center',
            fixed: "right",
            width: "170",
            content: (item: any) => (
                <>
                    <a href={item?.attachmentDetails?.url}
                       target="_blank" rel="noreferrer"
                    >
                        <PictureAsPdfIcon/>
                    </a>
                </>
            )
        },
        // {
        //     id: 'actions', label: 'Actions', align: "center",
        //     fixed: 'right',
        //     isDefaultColumn: true,
        //     width: '200',
        //     content: (item: any) => (
        //         <>
        //             <ButtonComponent
        //                 color={'primary'}
        //                 size={'small'}
        //                 variant={'outlined'}
        //                 startIcon={<RefreshOutlined/>}
        //                 handleClick={() => {
        //                     // downloadResultExcel(item?.attachmentDetails)
        //                 }}
        //             ></ButtonComponent>
        //         </>
        //     )
        // }
    ])


    return (
        <div className={'barcodes-products-based-list-component'}>
            <div className="table-list-container">
                <TableWrapperV2Component
                    isPaginated={true}
                    columns={columns}
                    url={APIConfig.GET_BULK_LIST_BARCODES.URL}
                    method={APIConfig.GET_BULK_LIST_BARCODES.METHOD}
                    extraPayload={filterData}
                    isColumnFilterVisible={false}
                    moduleName={'barcode-list-table'}
                />
            </div>
        </div>
    );

};

export default BarcodesListTableComponent;